import React from 'react';
import { IconProps } from './types';

export const AnchorIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      id="Laag_2"
      data-name="Laag 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={className}
    >
      <title>{title}</title>
      <path d="M29.26,16.74l-4.78-3.29-4.79,3.29a1.5,1.5,0,1,0,1.7,2.47L23.12,18a8.11,8.11,0,0,1-6.6,7.92V10.5H21a1.5,1.5,0,0,0,0-3H17.31a3.53,3.53,0,1,0-4.62,0H9a1.5,1.5,0,0,0,0,3h4.52V25.94a8.1,8.1,0,0,1-6.6-7.89l1.69,1.16a1.5,1.5,0,1,0,1.7-2.47L5.52,13.45.74,16.74a1.5,1.5,0,0,0,1.69,2.47l1.49-1a11.1,11.1,0,0,0,22.19,0l1.46,1a1.46,1.46,0,0,0,.84.26,1.5,1.5,0,0,0,.85-2.73Z" />
      <path d="M15,4.31a.54.54,0,1,1-.53.53A.53.53,0,0,1,15,4.31" />
    </svg>
  );
};
